import * as actionTypes from "../actions/actionTypes";
import {
  getAllCourses,
  getCourse,
  createCourse,
  updateCourse,
  deleteCourse,
  setLoader,
  pageIncreament,
  clearAll,
} from "../utility/courseFunctions";

const initialState = {
  courses: [],
  currentCourse: null,
  total: 0,
  isLoading: true,
  page: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_COURSES:
      return getAllCourses(state, action.courses, action.total);

    case actionTypes.GET_COURSE:
      return getCourse(state, action.course);

    case actionTypes.CREATE_COURSE:
      return createCourse(state, action.course);

    case actionTypes.UPDATE_COURSE:
      return updateCourse(state, action.course);

    case actionTypes.DELETE_COURSE:
      return deleteCourse(state, action.courseId);

    case actionTypes.SET_COURSE_LOADER:
      return setLoader(state, action.loaderValue);

    case actionTypes.COURSE_PAGE_INCREAMENT:
      return pageIncreament(state);

    case actionTypes.CLEAR_ALL_COURSES:
      return clearAll();

    default:
      return state;
  }
};

export default reducer; 